import router from './router'
import {
  familyTree
} from '@/utils/util'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

const allowList = ['login', 'main', 'search','detail','sdetail'] // no redirect allowList
const loginRoutePath = '/login'
const defaultRoutePath = '/main'

const routerArr = familyTree(router.options.routes) //获取所有页面路径
router.beforeEach((to, from, next) => {
  /* has token */
  console.log("ACCESS_TOKEN:",storage.get(ACCESS_TOKEN));
  if(to.path !== loginRoutePath && storage.get(ACCESS_TOKEN)==undefined)
  {
	  //没登录，回到登录页
	  next({ path: loginRoutePath })
  }
  
  if (storage.get(ACCESS_TOKEN)) 
  {
    if (to.path === loginRoutePath || !routerArr.includes(to.path)) 
	{
      next({ path: defaultRoutePath })
    } 
	else 
	{
      next()
    }
  } 
  else 
  {
    if (allowList.includes(to.name)) 
	{
      // 在免登录名单，直接进入
      next()
    } 
	else 
	{
      next({ path: loginRoutePath, query: { redirect: to.fullPath } })
    }
  }
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }

})

router.afterEach(() => {

})
